import React from "react";
import CurrencyFormat from "react-currency-format";
import { Radio } from "@rmwc/radio";
import { Checkbox } from "@rmwc/checkbox";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";

const LegHeightOptions = ({ params, const_var, heightOptions, isShowLiftReq, isInventoryorNot, setBuildingFlags, hasDoublelegBaiserail, handleLiftRequired }) => {
	const conditionData = const_var?.ConditionArr?.[params.p_b_t]?.[params.p_r_s];

	const customArray = conditionData?.CustomArray;

	const getLegLabel = (data) => {
		if (!data) return "";

		if (!const_var.isSingleBaseRail && !data.name.includes("Baserails")) {
			if (params.m_s_n == 122 && data.legs_type == "double") {
				return `${data.name} / Double Baserail`;
			}

			if (data.name?.toLowerCase()?.includes("double")) {
				return "Double Legs";
			}

			return data.name.includes("Baserail") ? data.name : `${data.name} Baserail `;
		}

		if (data.name?.toLowerCase()?.includes("double")) {
			return "Double Legs";
		}

		return data.name.includes("Baserail") ? data.name : `${data.name} Baserail `;
	};

	return (
		<>
			{heightOptions ? (
				<div className="col-6">
					<a className="more-link" onClick={() => setBuildingFlags("center")}>
						<span className="text">Leg Height Options</span>
						<span className="icon">
							<i className="icon-arrow-down-ico"></i>
						</span>
					</a>
				</div>
			) : null}

			{const_var?.commonBuildingFlag?.center?.buildingHeight === true && heightOptions ? (
				<div className="more-info">
					<p>The Reinforced/Double/Ladder/ZigZag legs strengthen the building and may require a lift to install the taller buildings.</p>

					{const_var.hasDoublelegshow === true && customArray && customArray.length > 1 ? (
						customArray.map((data, index) => (
							<div className="radio-group" key={index}>
								<Radio
									label={getLegLabel(data)}
									value={data.name}
									checked={const_var.legstype == data.legs_type && params.p_e_l}
									name={!const_var.isSingleBaseRail && !data.name.includes("Baserails") ? `${data.name} Baserail ` : data.name}
									onClick={(e) => hasDoublelegBaiserail(e.target.value, "center", data)}
								/>
							</div>
						))
					) : const_var.hasDoublelegshow === true && customArray && customArray.length == 1 ? (
						<div className="check-group">
							<Checkbox
								ripple="RipplePropF"
								label={getLegLabel(customArray[0])}
								disabled={const_var.hasDoublelegdisable}
								checked={params.p_e_l}
								onChange={(e) => hasDoublelegBaiserail(e.target.value, "center")}
							/>
						</div>
					) : null}

					{isShowLiftReq &&
					const_var.a_p_d_a?.side != undefined &&
					Object.keys(const_var.a_p_d_a.side).length > 0 &&
					const_var.a_p_d_a.side[0]?.lift_type != undefined &&
					const_var.a_p_d_a.side[0]?.lift_type != "" &&
					isInventoryorNot ? (
						<div className="check-group">
							<Checkbox
								ripple="RipplePropF"
								checked={params.lift_type}
								disabled={const_var.a_p_d_a.side.lifttype_price == 0}
								label={const_var.a_p_d_a.side[0].lift_type}
								onChange={(e) => handleLiftRequired(e.target.value)}
							/>

							<div className="price-box">
								{const_var.post_data.building !== undefined && const_var.loginSession == true && params.lift_type ? (
									<EditPriceItem jsonObj={const_var.post_data.building.lifttype_price !== undefined ? const_var.post_data.building.lifttype_price : 0} jsonObjKey="lifttype_price" />
								) : null}
							</div>

							<div className="price-box-type-2">
								{const_var.hide_price_calculation != 1 &&
									const_var.loginSession == false &&
									const_var.post_data.building !== undefined &&
									const_var.post_data.building.lifttype_price !== undefined &&
									const_var.post_data.building.lifttype_price !== 0 && <CurrencyFormat value={const_var.post_data.building.lifttype_price} displayType="text" thousandSeparator={true} prefix="$" />}
							</div>
						</div>
					) : null}
				</div>
			) : null}
		</>
	);
};

export default LegHeightOptions;
